// src/App.js
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AuthProvider } from "./contexts/AuthContext";
import { Outlet } from "react-router-dom";
import "./App.css";
import ScrollToHashElement from "./components/ScrollToHashElement";

const theme = createTheme({
  palette: {
    primary: {
      main: "#30B0C7",
      light: "#4FC3D7",
      dark: "#2798AC",
      contrastText: "#fff",
    },
    secondary: {
      main: "#C8E7EE",
      light: "#E1F2F6",
      dark: "#97D7E2",
      contrastText: "#000",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h3: {
      fontWeight: 500,
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <ScrollToHashElement />
        <Outlet />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
